import { attachComponentData } from '@backstage/core-plugin-api';

import {
  PAGE_CONTENT_ACTION_BAR_KEY,
  type PageContentActionBarProps,
} from './composition';

export type { PageContentActionBarProps };

export const ContentActionBar = (_props: PageContentActionBarProps): null =>
  null;

attachComponentData(ContentActionBar, PAGE_CONTENT_ACTION_BAR_KEY, true);
